<template>
<div class="weather" :class="detailedClass">
    <div class="weather-header">
     <b v-if="detailed">{{cityName}} (Forecast)</b>
     <router-link v-else :to="'/weather/'+woeid"><b>{{cityName}}</b></router-link>
    </div>
    <div class="weather-content">
        <Loader v-if="loading" text="Loading.." />
        <div v-else-if="!data || !data.consolidated_weather || !data.consolidated_weather.length" class="weather-data">
            <p><b>No data!</b></p>
        </div>
        <div v-else-if="!detailed" class="weather-data">
            <p><b>Today</b></p>
            <img class="weather-icon" :src="weather_icon(current.weather_state_abbr)" :alt="current.weather_state_name" :title="current.weather_state_name" />
            <p><span class="weather-details">{{format_temp(current.the_temp, 'celsius', 0, 1)}} ({{format_temp(current.min_temp, 'celsius', 0, 1)}} &mdash; {{format_temp(current.max_temp, 'celsius', 0, 1)}})</span></p>
            <p><span class="weather-details">{{format_num(current.wind_speed)}}mph</span> <i class="wind-dir" :class="current.wind_direction_compass.toLowerCase()"></i> ({{current.wind_direction_compass}})</p>
        </div>
        <template v-else>
        <div v-for="current in data.consolidated_weather" class="weather-data">
        <p><b>{{format_date( current.applicable_date )}}</b></p>
        <img class="weather-icon" :src="weather_icon(current.weather_state_abbr)" :alt="current.weather_state_name" :title="current.weather_state_name" />
        <p><span class="weather-details">{{format_temp(current.the_temp, 'celsius', 0, 1)}} ({{format_temp(current.min_temp, 'celsius', 0, 1)}} &mdash; {{format_temp(current.max_temp, 'celsius', 0, 1)}})</span></p>
        <p><span class="weather-details">{{format_num(current.wind_speed)}}mph</span><i class="wind-dir" :class="current.wind_direction_compass.toLowerCase()"></i> ({{current.wind_direction_compass}})</p>
        </div>
        </template>
    </div>
</div>
</template>

<script>
// @ is an alias to /src
import store from '@/modules/Store.js'
import Loader from '@/components/Loader.vue'

// temperature scales
const T = {
    fahrenheit: {symbol: '\u2109', celsius: t => ((5/9) * (t - 32)) },
    celsius: {symbol: '\u2103', fahrenheit: t => (t * 9 / 5 + 32) }
}

const API_URL = 'https://api.allorigins.win/get?url=' + encodeURIComponent('https://www.metaweather.com/api/location/');
//const API_URL = 'http://localhost:8080/weather.php?command=location&woeid=';
//const API_URL = '/weather.php?command=location&woeid=';

export default {
  name: 'Weather',
  components: {
    Loader
  },
  props: {
    woeid: String,
    city: String,
    detailed: Boolean
  },
  data: function( ) {
    return {
        cityName: this.city ? this.city : '..',
        loading: true,
        data: null,
        current: null
    };
  },
  computed: {
    detailedClass: function( ){
        return this.detailed ? 'detailed' : '';
    }
  },
  methods: {
    format_date: function format_date( strdate ) {
        const [year, month, day] = strdate.split('-');
        const date = new Date(strdate);
        const dayOfWeek =  date ? ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][date.getDay()] : 'Unknown';
        const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][month-1];
        return `${dayOfWeek}, ${monthName} ${day} ${year}`;
    },

    format_num: function format_num( n, p ) {
        return Math.round(+n); //(+n).toFixed(+(p || 2));
    },
    
    format_temp: function format_temp( t, scale, convert, withsymbol ) {
        scale = scale || 'celsius';
        if ( convert ) t = T['fahrenheit' === scale ? 'celsius' : 'fahrenheit'][scale](t);
        return this.format_num( t ) + (withsymbol ? T[scale].symbol : '');
    },

    weather_icon: function weather_icon( icon, type ) {
        return "https://www.metaweather.com/static/img/weather/"+icon+"."+(type||"svg").toLowerCase();
    }
  },
  mounted: function(){
        if ( !this.woeid ) return;

        let weatherData = store.get('weather_'+this.woeid);
        if ( weatherData ) {
            this.cityName = weatherData.title;
            this.data = weatherData;
            this.current = weatherData.consolidated_weather[0];
            this.loading = false;
        } else {
            fetch(API_URL+this.woeid)
            .then(response => response.json())
            .then(jsonResponse => {
                if (jsonResponse.contents) jsonResponse = JSON.parse(jsonResponse.contents);
                store.set('weather_'+this.woeid, weatherData = jsonResponse);
                this.cityName = weatherData.title;
                this.data = weatherData;
                this.current = weatherData.consolidated_weather[0];
                this.loading = false;
            });
        }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.weather {
    box-sizing: border-box;
    position: relative;
    display: inline-block;
    float: left;
    width: 30%;
    min-width: 300px;
    font-size: 1.4em;
    padding: 2px 10px;
    margin: 2px 4px;
    border: 1px solid #ccc;
}
.weather.detailed {
    width: 100%;
    border: none;
}
.weather-header {
    position: relative;
    display: block;
    box-sizing: border-box;
}    
.weather-content {
    position: relative;
    display: block;
    box-sizing: border-box;
}    
.weather-data {
    box-sizing: border-box;
    position: relative;
    display: block;
    padding: 4px;
    margin: 0 auto;
    border: none;
}
.weather-icon {
    display: block;
    position: relative;
    max-width: 90%;
    margin: 0 auto;
}
.weather-details {
    position: relative;
    display: inline-block;
}
.weather.detailed .weather-data {
    display: inline-block;
    width: 30%;
    min-width: 300px;
    float: left;
    padding: 2px 10px;
    margin: 2px 4px;
    border: 1px solid #ccc;
}
.weather:after, .weather-content:after {
    content: "";
    display: table;
    clear: both;
}

.wind-dir {
    position: relative;
    display: inline-block;
    font-size: 1.4em;
}
.wind-dir:after {
    position: relative;
    display: inline-block;
    content: "➙";
}

.wind-dir.e:after {
    transform: rotate(0deg);
}
.wind-dir.w:after {
    transform: rotate(-180deg);
}
.wind-dir.n:after {
    transform: rotate(-90deg);
}
.wind-dir.s:after {
    transform: rotate(90deg);
}
.wind-dir.ne:after {
    transform: rotate(-45deg);
}
.wind-dir.nw:after {
    transform: rotate(-135deg);
}
.wind-dir.se:after {
    transform: rotate(45deg);
}
.wind-dir.sw:after {
    transform: rotate(135deg);
}
.wind-dir.ene:after {
    transform: rotate(-25deg);
}
.wind-dir.wnw:after {
    transform: rotate(-155deg);
}
.wind-dir.ese:after {
    transform: rotate(25deg);
}
.wind-dir.wsw:after {
    transform: rotate(-205deg);
}
.wind-dir.nne:after {
    transform: rotate(-75deg);
}
.wind-dir.nnw:after {
    transform: rotate(-115deg);
}
.wind-dir.sse:after {
    transform: rotate(75deg);
}
.wind-dir.ssw:after {
    transform: rotate(115deg);
}
</style>
